const META_DATA_CHANNEL_LABEL = "metaDataChannel";
const MAXIMUM_MESSAGE_SIZE = 16384;
const BUFFERED_AMOUNT_LOW_THRESHOLD = 65536;
const START_OF_FILE_MESSAGE = "START";
const END_OF_FILE_MESSAGE = "EOF";
const CANCEL_MESSAGE = "CANCEL";

export {
  META_DATA_CHANNEL_LABEL,
  MAXIMUM_MESSAGE_SIZE,
  BUFFERED_AMOUNT_LOW_THRESHOLD,
  START_OF_FILE_MESSAGE,
  END_OF_FILE_MESSAGE,
  CANCEL_MESSAGE,
};
